import React  from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'

import * as rest from '../../services'
import { JSONToHTMLTable } from '../../components'
import { useDispatch } from 'react-redux'
import { showErrorToast, showSuccessToast } from '../../state/toasts'

export const QNADeleteButton = ({ record, onDelete }) => {
  const dispatch = useDispatch()
  let onReturnConfirm = function () {
    new rest.QNAService(record.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete(record)
        dispatch(showSuccessToast('Success', 'Q/A deleted successfully'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={onReturnConfirm}
        body="Are you sure you want to return this item?"
        confirmText="Confirm return item"
        confirmBSStyle="danger"
        title="Confirm return item"
      >
        <ReactBootstrap.Button
          disabled={record.is_deleted}
          variant="danger"
          eventKey="1"
        >
          {components.ICONS.DELETE}
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}

const QNALine = ({ ticket, qna, onTicketUpdate }) => {
  return (
    <ReactBootstrap.Row>
      <ReactBootstrap.Col className="p-0" xs="6">
        <strong>Data:</strong>
        {qna && qna.data && <JSONToHTMLTable data={qna.data} />}
      </ReactBootstrap.Col>
      <ReactBootstrap.Col className="text-end p-0" xs="6">
        <QNADeleteButton
          onDelete={() => {
            onTicketUpdate({...ticket,qna:[ticket.qna.filter((x)=>x.url != qna.url)]})
          }}
          record={qna}
        />
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}

export const TicketSavedQnA = ({ ticket, onTicketUpdate }) => {
  return (
    <>
      <ReactBootstrap.Card className="mt-5">
        <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">Saved Q/A</ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Card.Title>
        <ReactBootstrap.Card.Body>
          {ticket.qna.length ? (
            <components.ItemList
              itemRenderer={(index, key) => {
                return (
                  <ReactBootstrap.Col key={ticket.qna[index].url}>
                    <QNALine
                      ticket={ticket}
                      onTicketUpdate={onTicketUpdate}
                      qna={ticket.qna[index]}
                    />
                  </ReactBootstrap.Col>
                )
              }}
              length={ticket.qna.length}
            />
          ) : (
            <ReactBootstrap.Alert variant={'info'}>
              No previous part request found.
            </ReactBootstrap.Alert>
          )}
        </ReactBootstrap.Card.Body>
      </ReactBootstrap.Card>
    </>
  )
}
